import { render } from "./AboutPopup.vue?vue&type=template&id=04500426&scoped=true"
import script from "./AboutPopup.vue?vue&type=script&lang=js"
export * from "./AboutPopup.vue?vue&type=script&lang=js"

import "./AboutPopup.vue?vue&type=style&index=0&id=04500426&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04500426"]])

export default __exports__